import React from 'react';
import '../../styles/aboutUs-page/hero/AboutUsHero.min.css';

const HeroSection = () => {
    return (
        <div className="about-us-hero-section w-100 bg-transp d-flex justify-content-center align-items-center section-separator">
            <h1 className='fw-bold display-4 bg-transp'>
                SOBRE NÓS
            </h1>
        </div>
    );
}

export default HeroSection;